import { supabase } from '@/shared/supabase/client'
import { supabaseConfig } from '@/shared/config/supabase'

export interface VidaasAuthStatus {
  cached: boolean
  expiresAt: string | null
}

export async function checkVidaasAuthStatus(): Promise<VidaasAuthStatus> {
  const { data: sessionData } = await supabase.auth.getSession()
  const token = sessionData?.session?.access_token
  if (!token) return { cached: false, expiresAt: null }

  try {
    const base = supabaseConfig.url.replace(/\/$/, '')
    const url = `${base}/functions/v1/vidaas-auth-status`

    const res = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        apikey: supabaseConfig.anonKey,
      },
    })
    if (!res.ok) return { cached: false, expiresAt: null }
    const body = (await res.json()) as Partial<VidaasAuthStatus>
    return {
      cached: Boolean(body.cached),
      expiresAt: typeof body.expiresAt === 'string' ? body.expiresAt : null,
    }
  } catch {
    return { cached: false, expiresAt: null }
  }
}
